import { Fragment, useEffect, useState } from "react";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Swal from "sweetalert2";
import "./SelectLoan.scss";

// components
import MainHeader from "../../components/Header/MainHeader";
import CustomButton from "../../components/Button/CustomButton";

import EMIsAPI from "../../services/emi-api";
import { useNavigate } from "react-router-dom";
import { showManualContextualLoader } from "../../utils/contextualLoaderTrigger";
import { setStepperDisable } from "../../redux/slices/userSlice";
import { useDispatch } from "react-redux";
import { googleEvent_LOJ086, googleEvent_LOJ090 } from "../../lib/google-analytics-loan-journey-events";
import { addSelectedLoan } from "../../redux/slices/registerSlice";
import LoanRejectModal from "./LoanRejectModal";
import { START_FINBOX_FLOW_LOCAL_KEY, 
  MONTH_12_FLAGS_STATUS, 
  IS_PERSONAL_LOAN_SELECTED,
  EMI_PLAN_LOCAL_STORAGE_KEY,
  OFFER_TYPE_LOCAL_STORAGE_KEY,
  SELECTED_PRADUCT_TYPE_ID_LOCAL_STORAGE_KEY
 } from "../../Constants/constant";
import { addUpgradeLoanAmount } from "../../redux/slices/userSlice";
import { 
  clevertap_sv_sel_your_loan, 
  clevertap_sel_your_loan_sel, 
  clevertap_sel_your_loan_continue_clk,
  clevertap_loan_details_pl_screen,
  clevertap_loan_details_pl_screen_click
} from "../../lib/clevertap-events";

export default function SelectLoan() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  // const [appLoading, setAppLoading] = useState(false);
  const [month12Flag, setMonth12Flag] = useState(null);
  const { saveKycConsent } = new EMIsAPI();
  const dispatch = useDispatch();
  const [show12MonthRejectModal, setShow12MonthRejectModal] = useState(false);
  const [kyconsent, setKyconsent] = useState(true);

  const navigate = useNavigate();
  let isStartFinboxFlow = localStorage.getItem(START_FINBOX_FLOW_LOCAL_KEY);
  const personalLoanCard = data?.find(item => item.isPL) || null;
  const otherLoanCard = data?.filter(item => !item.isPL) || [];

  const setEmiPlanInLocalStorage = (item) => {
    const emi_plan = item?.Titel?.trim()?.replace(/[-\s]+/g, "_")?.toLowerCase();
    localStorage.setItem(EMI_PLAN_LOCAL_STORAGE_KEY, emi_plan);
    return emi_plan;
  }

  const setProductTypeIdInLocalStorage = (item) => {
    const product_type_id = item?.ProductID;
    localStorage.setItem(SELECTED_PRADUCT_TYPE_ID_LOCAL_STORAGE_KEY, product_type_id);
    return product_type_id;
  }

  useEffect(() => {
    const fetchAPI = async () => {
      const { paydayEMILoanListAPI } = new EMIsAPI();
      const res = await paydayEMILoanListAPI();
      if (res?.status === "1") { 
        setMonth12Flag(res?.month12_flag);
        let data = res.data || [];
        if(res?.month12_flag === MONTH_12_FLAGS_STATUS.PROCEED_TO_BANK){
          data = [{
              Titel: "Get up-to ₹5,00,000/-",
              TenureDetails: {
                Tenure: "12",
                Message: "Loan Tenure"
              },
              ProductID: 1,
              isPL: true,
              finbox_required: true
            }, ...data];
        }
        if(data?.length){
          const offer_type = data.length === 1 ? "single" : "multiple";
          localStorage.setItem(OFFER_TYPE_LOCAL_STORAGE_KEY, offer_type);
        }
        if(isStartFinboxFlow && (res?.month12_flag === MONTH_12_FLAGS_STATUS.PROCEED_TO_BANK || res?.month12_flag === null)){
          localStorage.removeItem(START_FINBOX_FLOW_LOCAL_KEY);
          isStartFinboxFlow=null
        }
        if(isStartFinboxFlow && res?.month12_flag === MONTH_12_FLAGS_STATUS.APPROVED){
          localStorage.removeItem(START_FINBOX_FLOW_LOCAL_KEY);
          redirectToLoanApproval(true, res.data);
          return;
        }

        setData(data);
        setSelectedData(data[0]);
        const emi_plan = setEmiPlanInLocalStorage(data[0]);
        setProductTypeIdInLocalStorage(data[0]);
        clevertap_sel_your_loan_sel({}, `sel_your_loan_${emi_plan}_auto_sel`);
      }
      setLoading(false);
    };

    fetchAPI();
    clevertap_loan_details_pl_screen();
  }, []);

  useEffect(() => {
    googleEvent_LOJ086();
    clevertap_sv_sel_your_loan();
  }, []);

  useEffect(() => {
    if(isStartFinboxFlow && month12Flag === MONTH_12_FLAGS_STATUS.NOT_ELIGIBLE) {
      setShow12MonthRejectModal(true);
    }
  }, [month12Flag, isStartFinboxFlow]);

  const handleApprovalROIView = async () => {
    dispatch(setStepperDisable(true));
    clevertap_loan_details_pl_screen_click({
      loan_amount: selectedData?.AmountDetails?.Amount || 'N/A'
    });
    clevertap_sel_your_loan_continue_clk();
    const kycDelay = 1000;
    try {
      const kycRes = await saveKycConsent(kyconsent);
      const { statusCode, message } = kycRes;
      const icon = statusCode === 200 ? "success" : 'error';
      if(statusCode !== 200) {
        setTimeout(() => {
            Swal.fire({
            icon,
            text: message,
            timer: kycDelay
          });
        }, kycDelay)
        return false;
      }
    } catch (error) {
      console.error(error?.response?.data?.message || 'somthing went wrong')
      return;
    }
    
    if(selectedData?.isPL && (selectedData?.finbox_required || month12Flag === MONTH_12_FLAGS_STATUS.PROCEED_TO_BANK)){
      dispatch(addUpgradeLoanAmount());
      localStorage.setItem(START_FINBOX_FLOW_LOCAL_KEY, true);
      localStorage.setItem(IS_PERSONAL_LOAN_SELECTED, true);
      navigate("/finbox-create");
      return;
    } else {
      localStorage.setItem(IS_PERSONAL_LOAN_SELECTED, false);
    }
    // setAppLoading(true);
    // const res = await approvalROIViewAPI(selectedData);
    // if (res.status === "1") {
    //   navigate("/loan-approval", { state: { ...res.data.emi_breakup, product_id: selectedData.ProductID } });
    // }

    // navigate("/loan-approval", { state: { ...selectedData } });
    
    redirectToLoanApproval(false, null);
    
  };

  const redirectToLoanApproval = (isPL, resData) => {
    const selectedLoan = isPL ? resData?.find(item => item.isPL) : selectedData ?? data[0];
    showManualContextualLoader("Saving your repayment preference…", 500);
    dispatch(addSelectedLoan(selectedLoan));
    googleEvent_LOJ090(selectedLoan, data);
    setTimeout(() => {
      navigate("/loan-approval");
    }, 500);
  }

  const cardImg = (Image, isPL) => {
    return (<div className="image">
      {
        isPL ? <img src="/images/12month.svg" alt="Personal Loan" /> : <img src={Image} alt="" />
      }
    </div>)
  };

  const renderLoanCard = (item) => {
    if (!item) return null;
    const { Titel, isPL, finbox_required, AmountDetails, TenureDetails, ProductID, Image } = item;
    const isSingleCard = data.length === 1;
    return (
      <div
        className={`loan-lists ${Titel === selectedData?.Titel ? "active" : ""} ${isSingleCard ? "single" : ""}`}
        onClick={() => {
          setSelectedData(item);
          const emi_plan = setEmiPlanInLocalStorage(item);
          setProductTypeIdInLocalStorage(item);
          clevertap_sel_your_loan_sel({}, `sel_your_loan_${emi_plan}_man_sel`);
        }}
      >   
        {isSingleCard ? cardImg(Image, isPL) : null}

        <h3>{Titel}</h3>
        {(isPL && finbox_required) && <p className="statementReq" style={{ marginTop: 5 }}>(Bank statement required) </p>}
        {/* <p>{item.SubTitle}</p> */}
        <div className="loan-card-content">

          <div className="content">
            {isPL ? <div className="congrateBadge"><img src="/images/congratulationsBadge.svg" /><span>Congratulations</span></div> : null}




            <div className="loan-details">
              {AmountDetails && <div>
                <p className="value">{AmountDetails.Amount}/-</p>
                <p className="label">{AmountDetails.Message}</p>
              </div>}
              <div>
                <p className="value">
                  {TenureDetails.Tenure}&nbsp;<span>{ProductID === 1 ? "Months" : "Days"}</span>
                </p>
                <p className="label">{TenureDetails.Message}</p>
              </div>
            </div>
          </div>
          {isSingleCard ? null : cardImg(Image, isPL)}
        </div>
      </div>
    )
  }

  return (
    <>
      <div className="wrapper selectLoan__page">
        <MainHeader title="Choose a loan offer" />

        <div className="mb-3">
          <p className="label">Pick the loan amount and tenure that suits you</p>
        </div>
        {
          personalLoanCard && <>
            {renderLoanCard(personalLoanCard)}
            {otherLoanCard?.length ? <div className="divider" /> : null}
          </>
        }
        {/* {
          (!personalLoanCard && MONTH_12_FLAGS_STATUS.PROCEED_TO_BANK)  && <>
            {renderLoanCard({
              Titel: "Get up-to ₹5,00,000/-",
              TenureDetails: {
                Tenure: "12",
                Message: "Loan Tenure"
              },
              ProductID: 1,
              isPL: true,
              finbox_required: false
            })}
          </>
        } */}
        {otherLoanCard?.length ? otherLoanCard?.map((item, index) => (
          <Fragment key={index}>
            {renderLoanCard(item)}
          </Fragment>
        )) : null}
        <div className="bottom-button-fixed">
          <FormControlLabel className="kyc-concent" control={
                <Checkbox defaultChecked 
                  onChange={(e) => setKyconsent(e.target.checked)}
                />
              } 
              label="I hereby confirm that my KYC details remain the same and unchanged." 
          />
          <CustomButton text="Continue" disabled={selectedData && kyconsent ? false : true} onClick={handleApprovalROIView} />
        </div>
      </div>
      {show12MonthRejectModal && <LoanRejectModal open={show12MonthRejectModal} onClose={() => setShow12MonthRejectModal(false)} />}
    </>
  );
}
